import type { AgrianTypes } from "../types/AgrianTypes";

/**
 * Checks whether an Agrian target event is associated with a specific field.
 * Agrian's wire format encodes the association under either a single id or
 * an array of ids — both shapes are handled here.
 *
 * Pure: no IO, no Date.
 */
export function isEventAssociatedWithField(event: AgrianTypes.HydratedTargetEvent, field: AgrianTypes.Field): boolean {
	const associationFieldId = event.associations?.["agrian.field"];
	return (
		!!event.associations &&
		!!associationFieldId &&
		((typeof associationFieldId === "string" && associationFieldId === field.id) ||
			(Array.isArray(associationFieldId) && associationFieldId.includes(field.id)))
	);
}
